export const trivia = {
  title: "April 2024 Solar Eclipse Quiz",
  questions:
  [
    {
        "q": "When will the April solar eclipse occur in 2024?",
        "a": ["April 8th", "April 16th", "April 22nd", "April 30th"]
      },
      {
        "q": "How long will the maximum phase of the eclipse (totality) last?",
        "a": ["Approximately 4 minutes", "Approximately 1 minute", "Approximately 9 minutes", "Approximately 21 minutes"]
      },
      {
        "q": "Which part of the world will have the best visibility of the eclipse (April 2024)?",
        "a": ["North America","Europe", "South America", "Asia"]
      },
      {
        "q": "What type of solar eclipse will the April 2024 eclipse be?",
        "a": ["Total eclipse", "Partial eclipse", "Annular eclipse", "Hybrid eclipse"]
      },
      {
        "q": "What is the correct way to observe a solar eclipse?",
        "a": ["Through eclipse glasses or special filters", "Directly without eye protection", "Using a mirror", "Taking a selfie with a mobile phone"]
      },
      {
        "q": "Which of the following statements is true about solar eclipses?",
        "a": ["They are more frequent than lunar eclipses", "They are always accompanied by lunar eclipses", "They are always accompanied by Earth eclipses", "They are less frequent than lunar eclipses"]
      },
      {
        "q": "How is a solar eclipse related to the phase of the Moon?",
        "a": ["It occurs during the new moon phase", "It occurs during the full moon phase", "It occurs during the crescent moon phase", "It occurs during the gibbous moon phase"]
      },{
        "q": "During a solar eclipse, which celestial body is positioned directly between the Earth and the Sun?",
        "a": ["Moon", "Mars", "Venus", "Jupiter"]
      },
      {
        "q": "Why doesn't a solar eclipse occur every month during the new moon phase?",
        "a": ["Because the Moon's orbit is tilted relative to the Earth's orbit around the Sun", "Because the Earth's shadow always falls on the Moon during the new moon phase", "Because the Moon is too far away from the Earth during the new moon phase", "Because the Sun's corona blocks the Moon during the new moon phase"]
      },
      {
        "q": "During a total solar eclipse, what is the name for the region on Earth where the total eclipse is visible?",
        "a": ["Path of totality", "Zone of annularity", "Partial eclipse zone", "Umbra region"]
      },
      {
        "q": "How often does a total solar eclipse occur in the same location on Earth?",
        "a": ["Approximately every 375 years", "Approximately every 25 years", "Approximately every 100 years", "Approximately every 50 years"]
      },
      {
        "q": "During a solar eclipse, what phenomenon occurs when the Moon does not completely cover the Sun, leaving a ring of sunlight visible around the edges?",
        "a": ["Annular eclipse", "Partial eclipse", "Total eclipse", "Hybrid eclipse"]
      },

  ]
}
